/* eslint-disable @typescript-eslint/no-explicit-any */
import { ColumnFilterItem, Key } from 'antd/es/table/interface';
import dayjs from 'dayjs';
import { DataStateItem } from 'shared/types';
import { EFieldType, IFieldMeta } from 'shared/types/Page.interface';
import { compareString, concatString } from 'shared/utils';
import { Filters } from './types';

export const prepareColumnFilters = (column: IFieldMeta, dataSource: any, activeFilters: Filters) => {
  if (dataSource) {
    let columnItems: ColumnFilterItem[] = [];

    if (column?.hideSortingDetail) {
      return {
        filters: null,
      };
    }

    switch (column.type) {
    case EFieldType.select:
      columnItems = dataSource.map((record: DataStateItem) => (
        {
          text: column.options[record[column.dataIndex as string] as string] || record[column.dataIndex],
          value: record[column.dataIndex as string] as string,
        }
      ));
      columnItems.sort((a, b) => compareString(a.text as string, b.text as string));
      break;
    case EFieldType.colored:
      columnItems = dataSource.map((record: DataStateItem) => (
        {
          text: column.selectOptions
            ? column.selectOptions[record[column.dataIndex as string] as string]
            : record[column.dataIndex as string],
          value: record[column.dataIndex as string] as string,
        }
      ));
      columnItems.sort((a, b) => compareString(a.text as string, b.text as string));
      break;
    case EFieldType.picklist:
      columnItems = dataSource
        .filter((record: DataStateItem) => !!record[column.dataIndex])
        .map((record: DataStateItem) => ({
          text: (record[column.dataIndex] as string)[column.pickMap.valueKey as any],
          value: (record[column.dataIndex] as string)[column.pickMap.nameKey as any],
        }));
      break;
    case EFieldType.template:
      columnItems = dataSource.map((record: DataStateItem) => (
        {
          text: concatString(
            column.keys.map(((key) => record[key] as string)),
          ),
          value: concatString(
            column.keys.map(((key) => record[key] as string)),
          ),
        }
      ));
      columnItems.sort((a, b) => compareString(a.text as string, b.text as string));
      break;
    case EFieldType.tags:
      return {
        filters: null,
      };
    case EFieldType.dateTime:
      columnItems = dataSource.map((record: DataStateItem) => (
        {
          text: dayjs(record[column.dataIndex] as string, column.sourceFormat).format(column.targetFormat),
          value: record[column.dataIndex as string] as string,
        }
      ));
      break;
    default:
      columnItems = dataSource.map((record: DataStateItem) => (
        { text: record[column.dataIndex as string] as string, value: record[column.dataIndex as string] as string }
      ));
      columnItems.sort((a, b) => compareString(a.text as string, b.text as string));
    }

    const getOnFilterFunction = () => {
      switch (column.type) {
      case EFieldType.template:
        return (value: boolean | Key, record: DataStateItem) => concatString(
          column.keys.map(((key) => record[key] as string)),
        ) === value;
      case EFieldType.picklist:
        return (value: boolean | Key, record: DataStateItem) => (
          record[column.dataIndex] && (record[column.dataIndex] as string)[column.pickMap.nameKey as any] === value
        );
      default:
        return (value: boolean | Key, record: DataStateItem) => record[column.dataIndex as string]?.toString() === value.toString();
      }
    };

    const uniqueColumnItems = [...new Map(columnItems
      .filter((item) => !!item.text && !!item.value)
      .map((item) => [item.text as string, item])).values()];

    return {
      filters: uniqueColumnItems,
      onFilter: getOnFilterFunction(),
      filterSearch: true,
      filteredValue: activeFilters[column.dataIndex] || null,
    };
  }
  return {};
};
